export default __webpack_public_path__ + "static/nate-lily-color-30ce1db7ed6d38d439a6c4d1512ac0c6.webp";